/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ScenarioChatIndexPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ScenarioChatIndexPageQuery = { scenarioChats: { scenarioChats: Array<{ guid: string, title: string }> } };

export type DeleteScenarioChatMutationVariables = Exact<{
  guid: string | number;
}>;


export type DeleteScenarioChatMutation = { deleteScenarioChatV2:
    | { __typename: 'DeleteScenarioChatErrorAssociatedWithIntroductionMessage', message: string }
    | { __typename: 'DeleteScenarioChatSuccess', success: boolean }
   };


export const ScenarioChatIndexPageDocument = gql`
    query ScenarioChatIndexPage {
  scenarioChats {
    scenarioChats {
      guid
      title
    }
  }
}
    `;

/**
 * __useScenarioChatIndexPageQuery__
 *
 * To run a query within a Vue component, call `useScenarioChatIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioChatIndexPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useScenarioChatIndexPageQuery();
 */
export function useScenarioChatIndexPageQuery(options: VueApolloComposable.UseQueryOptions<ScenarioChatIndexPageQuery, ScenarioChatIndexPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ScenarioChatIndexPageQuery, ScenarioChatIndexPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ScenarioChatIndexPageQuery, ScenarioChatIndexPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ScenarioChatIndexPageQuery, ScenarioChatIndexPageQueryVariables>(ScenarioChatIndexPageDocument, {}, options);
}
export function useScenarioChatIndexPageLazyQuery(options: VueApolloComposable.UseQueryOptions<ScenarioChatIndexPageQuery, ScenarioChatIndexPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ScenarioChatIndexPageQuery, ScenarioChatIndexPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ScenarioChatIndexPageQuery, ScenarioChatIndexPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ScenarioChatIndexPageQuery, ScenarioChatIndexPageQueryVariables>(ScenarioChatIndexPageDocument, {}, options);
}
export type ScenarioChatIndexPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ScenarioChatIndexPageQuery, ScenarioChatIndexPageQueryVariables>;
export const DeleteScenarioChatDocument = gql`
    mutation DeleteScenarioChat($guid: ID!) {
  deleteScenarioChatV2(guid: $guid) {
    __typename
    ... on DeleteScenarioChatSuccess {
      success
    }
    ... on DeleteScenarioChatErrorAssociatedWithIntroductionMessage {
      message
    }
  }
}
    `;

/**
 * __useDeleteScenarioChatMutation__
 *
 * To run a mutation, you first call `useDeleteScenarioChatMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScenarioChatMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteScenarioChatMutation({
 *   variables: {
 *     guid: // value for 'guid'
 *   },
 * });
 */
export function useDeleteScenarioChatMutation(options: VueApolloComposable.UseMutationOptions<DeleteScenarioChatMutation, DeleteScenarioChatMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteScenarioChatMutation, DeleteScenarioChatMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteScenarioChatMutation, DeleteScenarioChatMutationVariables>(DeleteScenarioChatDocument, options);
}
export type DeleteScenarioChatMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteScenarioChatMutation, DeleteScenarioChatMutationVariables>;